import Vue from 'vue'
import LayoutMainInner from '@/components/layout/layout-main-inner'
import LayoutCardWrap from '@/components/layout/layout-card-wrap'
import LinkRoute from '@/components/public/link-route'
import BackButton from '@/components/public/back-button'
import Empty from '@/components/public/empty'
import PaginationNew from '@/components/pagination-new.vue'
import UploadNew from '@/components/upload-new.vue'
const components = [LayoutMainInner, LayoutCardWrap, LinkRoute, BackButton, Empty, PaginationNew, UploadNew]

components.forEach(component => {
  Vue.component(component.name, component)
})
